import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "./SobreNosotros.css"
import imagenSobre from "../images/imagen-sobrenosotros.png"
import { Button } from 'flowbite-react';
import { Link } from "react-scroll";
import 'animate.css';

const buttonStyleAzul = {
    backgroundColor: '#111125',
    color: 'white',
    borderRadius: '28px',
    fontFamily: 'Inter, sans-serif', 
    fontSize: '24px',
    fontWeight: 'semi-bold',
  };

function SobreNosotros() {
  return (
    <Container className='contenedor-sobrenosotros'>
        <Row>
            <Col className="d-flex align-items-center col-md-5 d-none d-sm-block animate__animated animate__fadeInUp">
                <div className='contenedor-imagen'>
                    <img src={imagenSobre} className="imagenInicio d-flex align-items-center" alt="logo" />
                </div>
            </Col>
            {/* <Col className='col-lg-1' ></Col> */}
            <Col className='col-md-7 col-sm-12 '>
                {/* <h5 className='pretitulo'>Lorem Ipsum Dolor</h5> */}
                <h4 className='titulo-blanco animate__animated animate__fadeInUp'>Somos una empresa <br /><span className='titulo-azul'>Growth Partner</span></h4>
                <p className='parrafo animate__animated animate__fadeInUp'>En nuestro modelo de empresa tenemos la capacidad para aportarte el embudo de venta que se adapte para tu negocio.</p>
                <div className='contenedorEstadisticas animate__animated animate__fadeInUp'>
                    <div className='contenedor-numeros'>
                        <p className='texto-numeros'>100<span className='texto-numeros-azul'>%</span></p>
                        <p className='texto-estadisticas'>Satisfaccion de clientes</p>
                    </div>
                    <div className='contenedor-numeros'>
                        <p className='texto-numeros'>15</p>
                        <p className='texto-estadisticas'>Clientes activos</p>
                    </div>
                    <div className='contenedor-numeros'>
                        <p className='texto-numeros'>+12<span className='texto-numeros-azul'>K</span></p>
                        <p className='texto-estadisticas'>Invertidos Anualmente</p>
                    </div>
                </div>
                <div className='contenedor-boton gap-2'>
                    <Link  to='calendly' smooth={false} offset={-70} duration={700} color="text">
                        <Button className='mt-10 p-0 animate__animated animate__fadeInUp' size="lg" style={buttonStyleAzul}>Agendemos una llamada</Button>
                    </Link>
                </div>
            </Col>
        </Row>
    </Container>
  )
}

export default SobreNosotros
